import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';
import { PrinterProduct } from './printerproduct';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { PrinterProductType } from '../types';
import { ProductOptType } from '../types';

const _schema = {
    'name': 'PRINTERPRODUCTOPT',
    'fields': [
        { name: 'status', type: 'string', default: 'AC' },
        { name: 'product', type: 'objid' },
        { name: 'prodopt', type: 'objid', alias: 'option' },
    ],
    relate: [
        { direction: '>', target: 'PRINTERPRODUCT', by: 'product', name: 'product', reason: 'product', child: false, class: PrinterProductType },
        { direction: '>', target: 'PRODUCTOPT', by: 'option', name: 'option', reason: 'option', child: false, class: ProductOptType },
    ],
} as const;

const _PrinterProductOptClass = CreateObject(_schema);
if (!_PrinterProductOptClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class PrinterProductOpt extends _PrinterProductOptClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): PrinterProductOpt {
        return this._Copy(store) as PrinterProductOpt;
    }

    /** Changelog rows lack parent 1:N lists; register on link (see Preselect / TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'product' && related instanceof PrinterProduct){
            if (related === this.product){
                related.AddOption(this);
            }
        }
    }

    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.product){
            if ((this.status == 'DE') && !this.Commited){
                this.product.DelOption(this);
            }
            else {
                this.product.DoRefresh(this.table);
            }
        }
    }

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}
